import axios from 'axios'
import qs from 'qs'
import store from '../store'
/* eslint-disable */
const wwwForm = 'application/x-www-form-urlencoded'
const contentType = 'Content-Type'
axios.defaults.headers[contentType] = wwwForm

declare const process: any;
// 从配置文件中读取的baseUrl
const envBaseUrl = process.env.VUE_APP_API

// 创建axios实例
const service = axios.create({
    baseURL: envBaseUrl, // 项目根目录的base_url
    timeout: 150000, // 请求超时时间
    // withCredentials: true,
})

// request拦截器
service.interceptors.request.use(config => {
    if (store.getters.token) {
        config.headers['Access-Token'] = store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    const method = (config.method || '').toLowerCase()
    if (method == 'post' || method == 'put') {
        if (config.data && typeof config.data != 'string') {
            config.data = qs.stringify(config.data)
        }
    }
    console.log(envBaseUrl)
    return config
}, error => {
    console.log(error)
    Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
    rsp => {
        if (rsp.status < 200 || rsp.status > 300) {
            console.log(rsp.status)
        }
        if (rsp.data.code == 401) {
            // console.log(document.URL)
            // const back = document.URL
            // const base = process.env.VUE_APP_BASE
            // const target = base + '/#/start?back=' + encodeURIComponent(back)
            // console.log({ target, env: process.env })
            // document.location.href = target
        }
        return rsp.data
    },
    error => {
        // console.log({ url: error.config.url, error, }) // for debug
        return Promise.resolve({
            code: -100,
            message: error.message
        })
    }
)

export default service
